import { useCallback } from 'react';

import { useCanvas } from '../../../../core/components/canvas/hooks/useCanvas.js';
import { DATA_POINT_OUTER_RADIUS } from '../../../../core/components/data-point/constants.js';
import { getStrokeColor } from '../../../../core/components/data-point/utils/data-point.js';
import { DEFAULT_DATA_POINT_RADIUS } from '../../../../core/constants.js';
import { DataPoint } from '../../../../core/types/data-point.js';
import { drawShapeFill, drawShapeStroke } from '../utils/draw-shape.js';

interface HighlightedDatapointCanvasProps {
  points: DataPoint[];
}

export const HighlightedPointCanvas = ({
  points,
}: HighlightedDatapointCanvasProps) => {
  const draw = useCallback(
    (ctx: CanvasRenderingContext2D) => {
      const strokeColor = getStrokeColor(points);
      for (const point of points) {
        drawShapeStroke(ctx, point, DATA_POINT_OUTER_RADIUS, strokeColor);
        drawShapeFill(ctx, point, DEFAULT_DATA_POINT_RADIUS);
      }

      return false;
    },
    [points],
  );

  useCanvas('Highlighted-DataPoints', draw);

  return null;
};
